import { GlobalContext, QuoteData, defaultValues } from "@/components/context/GlobalContext"
import { FC, ReactNode, useState } from "react"
type Props = {
  children: ReactNode
}
const GlobalContextProvider: FC<Props> = ({ children }) => {
  const [isReportMode, setIsReportMode] = useState(defaultValues.isReportMode)
  const [itemId, setItemId] = useState<Maybe<string>>(null)
  const [geometryInfo, setGeometryInfo] = useState(defaultValues.geometryInfo)
  const [pageModeGlobal, setPageModeGlobal] = useState(defaultValues.pageModeGlobal)
  const [createQuoteData, setCreateQuoteData] = useState<QuoteData | null>(defaultValues.createQuoteData)
  const [loginEmail, setLoginEmail] = useState<Maybe<string>>(defaultValues.loginEmail)
  const [orgIds, setOrgIds] = useState<Maybe<string[]>>(defaultValues.orgIds)
  const [currentLink, setCurrentLink] = useState<Maybe<string>>(defaultValues.currentLink)
  const [currentDeliveryIds, setCurrentDeliveryIds] = useState<string[]>(defaultValues.currentDeliveryIds)

  return (
    <GlobalContext.Provider
      value={{
        orgIds,
        setOrgIds,
        geometryInfo,
        setGeometryInfo,
        isReportMode,
        setIsReportMode,
        itemId,
        setItemId,
        pageModeGlobal,
        setPageModeGlobal,
        createQuoteData,
        setCreateQuoteData,
        loginEmail,
        setLoginEmail,
        currentLink,
        setCurrentLink,
        currentDeliveryIds,
        setCurrentDeliveryIds,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

export default GlobalContextProvider
